import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild, ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import {CalendarComponent} from "../calendar/calendar.component";
import {NgForOf} from "@angular/common";
import { initFlowbite } from 'flowbite';
import {PrestazioneService} from "../../services/prestazione.service";
import {Prestazione} from "../../models/prestazione.model";
import moment from "moment";
import {ActivatedRoute} from "@angular/router";
import {ScrollPositionService} from "../../services/scroll-position.service";
import {CreateComponent} from "../../prenotazione/create/create.component";
import {EditComponent} from "../../prenotazione/edit/edit.component";
import { Router } from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-swiper',
  standalone: true,
  imports: [
    CalendarComponent,
    NgForOf,
    CreateComponent,
    EditComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './swiper.component.html',
  styleUrl: './swiper.component.css',
  encapsulation: ViewEncapsulation.None
})
export class SwiperComponent implements OnInit, AfterViewInit{

  @ViewChild('slide1') slide1!: ElementRef;
  @ViewChild('slide2') slide2!: ElementRef;
  private scrollPosition = 0;

  //Inizio della giornata e fine della giornata
  day: string = moment().format('YYYY-MM-DD');

  //Prenotazioni
  prestazioni: Prestazione[] = [];
  prestazioni1: Prestazione[] = [];
  prestazioni2: Prestazione[] = [];

  // Tempo di inattività
  private inactivityTimeout: any;


  constructor(
    public prestazioneService: PrestazioneService,
    private route: ActivatedRoute,
    private scrollPositionService: ScrollPositionService,
    private router: Router
  ) { }

  ngOnInit() {
    initFlowbite();

    // Modularità auto refresh
    if(environment.autoRefresh){
      this.resetInactivityTimer();
      this.addInactivityListeners();
    }

    this.route.params.subscribe(params => {
      this.day = params['day'] ? params['day'] : moment().format('YYYY-MM-DD');
    });

    //Recupero da BE le prestazioni
    this.prestazioneService.index()
      .subscribe((responseData) => {
        this.prestazioni = responseData.prestazioni;

        //Recupero le macchine per la prima slide
        this.prestazioni1 = this.prestazioni
          .filter(prestazione => prestazione.slide === 1);

        //Recupero le macchine per la seconda slide
        this.prestazioni2 = this.prestazioni
          .filter(prestazione => prestazione.slide === 2);
      });
  }

  addScrollListener(sourceSlide: ElementRef, targetSlides: ElementRef[]) {
    sourceSlide.nativeElement.addEventListener('scroll', (event: Event) => {
      const scrollTop = (event.target as Element).scrollTop;
      this.scrollPositionService.setScrollPosition(scrollTop);
      targetSlides.forEach(slide => {
        slide.nativeElement.scrollTop = scrollTop;
      });
    });
  }

  ngAfterViewInit() {
    const scrollPosition = this.scrollPositionService.getScrollPosition();
    this.slide1.nativeElement.scrollTop = scrollPosition;
    this.slide2.nativeElement.scrollTop = scrollPosition;

    this.addScrollListener(this.slide1, [this.slide2]);
    this.addScrollListener(this.slide2, [this.slide1]);
  }

  private resetInactivityTimer() {
    if (this.inactivityTimeout) {
      clearTimeout(this.inactivityTimeout);
    }
    this.inactivityTimeout = setTimeout(() => {
      if (this.day !== moment().format('YYYY-MM-DD')) {
        this.router.navigate(['/calendario']);
      }
    }, 30000); // 30 seconds
  }

  private addInactivityListeners() {
    ['mousemove', 'keypress', 'scroll'].forEach(event => {
      window.addEventListener(event, () => this.resetInactivityTimer());
    });
  }

  // Variabili per i modali di creazione e modifica
  @ViewChildren(CalendarComponent) calendars!: QueryList<CalendarComponent>;
  date = moment(); // Data corrente
  prestazione: Prestazione | null = null; // Prestazione selezionata
  hour: number = 9; // Ora di inizio
  minutes: number = 20; // Minuti di inizio
  prenotazione: any; // Prenotazione selezionata
  isVisibleCreate: boolean = false; // Visibilità del modal
  isVisibleEdit: boolean = false; // Visibilità del modal

  // Metodo per la selezione di uno slot
  onSlotSelected(event: {prestazione: any, date: any, hour: number, minutes: number, isVisible: boolean}) {
    this.prestazione = event.prestazione;
    this.date = event.date;
    this.hour = event.hour;
    this.minutes = event.minutes;
    this.isVisibleCreate = event.isVisible;
  }

  // Metodo per la modifica di uno slot
  onSlotEdit(event: {prestazione: any, prenotazione: any, hour: number, minutes: number, isVisible: boolean}) {
    this.prestazione = event.prestazione;
    this.prenotazione = event.prenotazione;
    this.hour = event.hour;
    this.minutes = event.minutes;
    this.isVisibleEdit = event.isVisible;
  }

  // Chiude il modal
  onCloseModal() {
    this.isVisibleCreate = false;
    this.isVisibleEdit = false;
  }

}
